<template>
<div class="chapter">
<div class="inner_page">
<p class="SWchapter" id="calibre_pb_2">PROLOGUE</p>
<p class="c3"><a id="Prologue"></a> There are times
in life where the world suddenly surprises you. Or perhaps, you
suddenly surprise yourself. I’m not sure which it is, but right now
it really doesn’t matter to me.</p>
<p class="western">I’m lying on the beach, staring up at the
sky. The sand is wet and solid, and trickles of small waves are
licking at my toes and creeping under me. There is a beautiful man
lying to my left, and I am about to call the most amazing man in
the world, the one I have waited over twenty years to meet, but
wasn’t sure existed.</p>
<p class="western">I am not sure why they call it a mid-life
crisis. I don’t know why they don’t call it “A Time of Great
Revolution,” or “When the World is Full of Epiphanies,” or better
yet, “When You Finally Know Who You Are, and What the Fuck You are
Supposed to Do.” That’s what I want to call this time in my
life.</p>
<p class="western">You see, at this age, we have often
forgotten who we are, but recently, I remembered. I remembered so
hard, and so fast, that my head is spinning. I finally know what I
want out of this world, and I think I'm even starting to figure out
how to get it. Sure, maybe it took a few steps in a direction that
some people might call a crisis. Maybe some people would say I
stole a man from my nephew, and I am sure there are those who think
that I’ve lost my mind, but you see, I ended up exactly where I am
supposed to be. I might have tripped into this place, or more like
drunkenly stumbled, but I made it. I made it!</p>
<p class="western">As I am thinking all of this, the tide is
coming in harder and higher, covering parts of me and then pulling
away. I should be worried, but I am loving it. I lie flat and let
the water flow all around me. Perhaps I’ll get up in a minute.
Maybe I’ll have to. It doesn’t matter though. As I lie here just
enjoying the tide rushing in closer and closer, I suddenly hear a
thud. I look to my right. A large jellyfish has just landed near
me. Its legs are outstretched, one of them only two or three inches
from me. I know I should be scared. I should be concerned and
worried. But I’m not. Instead of screaming, I laugh, and I laugh,
and I laugh, and I remember a story that someone once told me.</p>
<p class="western">The gorgeous man on my left laughs as well,
and we watch the tide return the jellyfish to the sea as the water
almost completely covers our bodies. The jellyfish is the sort of
reminder we needed, the one that tells you that once again, life
has surprised you. It’s the kind of surprise that those of us who
live by the water have come to expect. My name is Mark Dauphin, and
this is my story.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_003.vue?34c3e360